import { useEffect, useState } from "react";
import { Spinner } from 'react-bootstrap';

import { Validators } from "../../../shared/utils/Validators";
import { TextAreaInput, TextInput } from "../../../shared/form/FormInput";
import { siteDetail, sitesAdd } from "../../../shared/settings/apiConfig";
import { getApi, postApi, putApi } from "../../../shared/services/apiHelper";

import './SiteAddEdit.scss';
import { BuildingIcon, LocationIcon, PlusIcon } from "../../../shared/icons/Icons";

export const SiteAddEdit = (props) => {

    const isEdit = props.location.pathname.includes('edit');
    const siteId = props.location.pathname.includes('add') ? '' : props?.match?.params?.id;

    const [initialLoading, setInitialLoading] = useState(isEdit);
    const [siteForm, setSiteForm] = useState({
        name: { value: '', valid: false, error: '', validators: [Validators.required()] },
        location: { value: '', valid: false, error: '', validators: [Validators.required()] },
        description: { value: '', valid: true, error: '', validators: [] },
    });

    const [formLoading, setFormLoading] = useState(false);
    const [formValid, setFormValid] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        if (siteId && isEdit) {
            setInitialLoading(true);
            getApi(`${siteDetail}/${siteId}`).then((response) => {
                let data = response.data;
                setSiteForm(prevState => {
                    return Validators.validateAndSetAllFormControls(prevState, data)
                })
                setInitialLoading(false);
            }).catch((error) => {
                console.log(error);
                setInitialLoading(false);
            });
        }
    }, [siteId, isEdit]);

    useEffect(() => {
        setFormValid(Validators.validateForm(siteForm));
    }, [siteForm]);

    const inputChange = (type, event) => {
        setSiteForm(prevState => {
            return {
                ...prevState,
                [type]: Validators.validateFormControl(prevState[type], event.target.value)
            }
        })
    };

    const onCancel = () => {
        props.history.goBack();
    }

    const onSaveSite = () => {
        setFormLoading(true);
        let data = {
            "name": siteForm.name.value,
            "location": siteForm.location.value,
            "description": siteForm.description.value,
        };

        if (isEdit) {
            // Backend expects PUT /api/sites/{site_id} without id in payload
            putApi(`${sitesAdd}${siteId}`, data).then((response) => {
                if (response.data?.updated || response.status === 200) {
                    props.history.goBack();
                }
                setFormLoading(false);
            }).catch((error) => {
                setFormLoading(false);
                setErrorMessage(error.response?.data?.detail || "Error updating site");
                setTimeout(() => {
                    setErrorMessage('');
                }, 3000);
            })
        } else {
            postApi(sitesAdd, data).then((response) => {
                if (response.status === 200 || response.status === 201) {
                    props.history.goBack();
                }
                setFormLoading(false);
            }).catch((error) => {
                setFormLoading(false);
                setErrorMessage(error.response?.data?.detail || "Error creating site");
                setTimeout(() => {
                    setErrorMessage('');
                }, 3000);
            })
        }
    }

    return (
<>
        <div className=" mt-5">
        <div className="site-add-edit-container container">
            <div className="page-header">
                <h4 className="page-title">
                    <BuildingIcon color="#9333ea" />{isEdit ? "Edit Site" : "Add New Site"}
                </h4>
                <p className="page-subtitle">Enter site details to {isEdit ? "update" : "add"} a construction site</p>
            </div>
            {
                initialLoading ? (
                    <div className="loader-container">
                        <img className='loader-icon' src={`${process.env.PUBLIC_URL}/static/images/loader.svg`} alt="loader-icon" />
                    </div>
                ) : (
                    <>
                        <div className="form-cards-container">
                            <div className="form-card">
                                <div className="field-label">
                                    <span className="field-icon"><BuildingIcon color="#6b7280" /></span>
                                    SITE NAME<span className="required-asterisk">*</span>
                                </div>
                                <TextInput className="form-fontsize" type={'text'} name={'name'} label={''} placeholder={'Enter Site Name'}
                                    value={siteForm.name.value} error={siteForm.name.error} onChange={(event) => inputChange("name", event)} />
                            </div>

                            <div className="form-card">
                                <div className="field-label">
                                    <span className="field-icon"><LocationIcon color="#6b7280" /></span>
                                    LOCATION / ADDRESS<span className="required-asterisk">*</span>
                                </div>
                                <TextInput className="form-fontsize" type={'text'} name={'location'} label={''} placeholder={'Site Location / Address'}
                                    value={siteForm.location.value} error={siteForm.location.error} onChange={(event) => inputChange("location", event)} />
                            </div>

                            <div className="form-card">
                                <div className="field-label">DESCRIPTION</div>
                                <TextAreaInput className="form-fontsize" name={'description'} label={''} placeholder={'Description of the site...'} style={{ "minHeight": "5rem" }}
                                    value={siteForm.description.value} error={siteForm.description.error} onChange={(event) => inputChange("description", event)} />
                            </div>
                        </div>

                        {errorMessage && (
                            <div className="error-message">{errorMessage}</div>
                        )}

                        <div className="form-actions">
                            <button className="btn-cancel" onClick={onCancel}>
                                Cancel
                            </button>
                            <button className="btn btn-solid-blue fw-bold" onClick={onSaveSite} disabled={!formValid}>
                                <PlusIcon />{isEdit ? "Update Site" : "Add Site"} {formLoading ? <Spinner className='ms-2' as="span" animation="border" role="status" aria-hidden="true" /> : ''}
                            </button>
                        </div>
                    </>
                )
            }
        </div></div>
        </>
    )
}